
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class DashboardGrid extends SiteEntityGrid<DashboardRow, any> {
        protected getColumnsKey() { return 'Dashboards.Dashboard'; }
        protected getDialogType() { return DashboardDialog; }
        protected getIdProperty() { return DashboardRow.idProperty; }
        protected getInsertPermission() { return DashboardRow.insertPermission; }
        protected getLocalTextPrefix() { return DashboardRow.localTextPrefix; }
        protected getService() { return DashboardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}